import { render, staticRenderFns } from "./DevelopmentCard.vue?vue&type=template&id=4706113e&scoped=true&"
import script from "./DevelopmentCard.vue?vue&type=script&lang=js&"
export * from "./DevelopmentCard.vue?vue&type=script&lang=js&"
import style0 from "./DevelopmentCard.vue?vue&type=style&index=0&id=4706113e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4706113e",
  null
  
)

export default component.exports